var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0C2.675 0 2.0075 0.63 2.0075 1.4L2 12.6C2 13.37 2.6675 14 3.4925 14H12.5C13.325 14 14 13.37 14 12.6V4.2L9.5 0H3.5Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1C1.675 1 1.0075 1.63 1.0075 2.4L1 13.6C1 14.37 1.6675 15 2.4925 15H11.5C12.325 15 13 14.37 13 13.6V5.2L8.5 1H2.5Z",
    fill: "#EFF3F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2C0.675 2 0.00750017 2.63 0.00750017 3.4L0 14.6C0 15.37 0.6675 16 1.4925 16H10.5C11.325 16 12 15.37 12 14.6V6.2L7.5 2H1.5Z",
    fill: "#255986"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#EFF3F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "#EFF3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.747f15ecb8bc08f70fb6db3c4534382d.svg";
export { ForwardRef as ReactComponent };